import React from "react";
import "./Review.css";
import { useModal } from "../../../context/modalContext"; // adjust path if needed

const maxChar = 250;

const cleanHtml = (html = "") =>
    html
        .replace(/&nbsp;/g, " ")
        .replace(/\u00A0/g, " ");

const stripHtml = (html = "") =>
    cleanHtml(html)
        .replace(/<[^>]*>/g, " ")
        .replace(/\s+/g, " ")
        .trim();

const ReviewModalContent = ({ review, onClose }) => {
    const fullHtml = cleanHtml(review?.text || "");

    return (
        <div className="Review Review__selected">
            <div className="Review__container">

                <div
                    dir="rtl"
                    className="Review__textFull hebrew-text"
                    dangerouslySetInnerHTML={{ __html: fullHtml }}
                />
            </div>
        </div>
    );
};

const Review = ({ review }) => {
    const { openModal, closeModal } = useModal();

    const plainText = stripHtml(review?.text || "");
    const hasMore = plainText.length > maxChar;
    const previewText = hasMore
        ? `${plainText.slice(0, maxChar)}...`
        : plainText;

    const handleReadMore = () => {
        openModal(
            <ReviewModalContent
                review={review}
                onClose={closeModal}
            />
        );
    };

    return (
        <div className="Review">
            <div className="Review__container">
                <div dir="rtl" className="Review__text hebrew-text">
                    {previewText}
                </div>

                {hasMore && (
                    <button
                        className="Review__readMore"
                        onClick={handleReadMore}
                    >
                        المزيد
                    </button>
                )}
            </div>
        </div>
    );
};

export default Review;